import React, { lazy } from 'react';

import { useWalletStatusProps } from '@/features/WalletConnect/hooks';
import { ConnectWallet, WalletConnectStatus } from '@/features/WalletConnect/ui';
import useLocalFeatureFlag from '@/shared/hooks/useLocalFeatureFlag';
import { Features } from '@/shared/configs/features';

type WalletConnectWrapperProps = {
    handleSetBannerState: (value: boolean) => void;
};

const BaseWalletConnectWrapper = ({ handleSetBannerState }: WalletConnectWrapperProps) => {
    const { disconnect } = useWalletStatusProps();

    return (
        <>
            <WalletConnectStatus disconnect={disconnect} />
            <ConnectWallet handleSetBannerState={handleSetBannerState} />
        </>
    );
};

const LazyWalletConnectWrapper = lazy(() =>
    import('./v2/WalletConnectWrapper').then((module) => ({
        default: module.WalletConnectWrapper,
    })),
);

export const WalletConnectWrapper = ({ handleSetBannerState }: WalletConnectWrapperProps) => {
    const isNewWalletConnect = useLocalFeatureFlag(Features.NewWalletConnect, true);

    if (!isNewWalletConnect) {
        return <BaseWalletConnectWrapper handleSetBannerState={handleSetBannerState} />;
    }

    return (
        <React.Suspense fallback={null}>
            <LazyWalletConnectWrapper handleSetBannerState={handleSetBannerState} />
        </React.Suspense>
    );
};
